import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import SnackbarCard from './SnackbarCard';
import SnackbarClose from './SnackbarClose';
import SnackbarLayout from './SnackbarLayout';
import SnackbarMedia from './SnackbarMedia';
import SnackbarContent from './SnackbarContent';
import SnackbarActionText from './SnackbarActionText';
import SnackbarTitle from './SnackbarTitle';

export default function SnackbarProviderConnectionVerify({ id, icon, message, action, onCancel }) {
    const { t } = useTranslation('providers');

    const handleAction = () => {
        toast.dismiss(id);
        action?.();
    };

    const handleCancel = () => {
        toast.dismiss(id);
        onCancel();
    };

    return (
        <SnackbarCard variant="actionRequired">
            <SnackbarClose onClick={() => toast.dismiss(id)} />
            <SnackbarLayout>
                <SnackbarMedia>
                    <img src={icon} alt="" />
                </SnackbarMedia>
                <SnackbarContent className="pr-4">
                    <SnackbarActionText>{t('approval-required')}</SnackbarActionText>
                    <SnackbarTitle>{message}</SnackbarTitle>
                    <div className="mt-2 flex justify-end gap-2">
                        {onCancel && (
                            <Button size="small" variant="ghost" className="px-2" onClick={handleCancel}>
                                {t('cancel-sync')}
                            </Button>
                        )}
                        <Button size="small" variant="primary" onClick={handleAction}>
                            {t('approve')}
                        </Button>
                    </div>
                </SnackbarContent>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarProviderConnectionVerify.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    action: PropTypes.func,
    onCancel: PropTypes.func,
};
